/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Views.Twitter = class Twitter {
  constructor(el, controller) {
    this._shareMessageChanged = this._shareMessageChanged.bind(this);
    this.el = el;
    this.controller = controller;
    this.messageBox = this.el.find("[data-personal-message]");
    this.shareLink = this.el.find("[data-share-link]");

    this._bindEvents();
    setTimeout(this._shareMessageChanged, 0);
  }

  updateShareLink(value) {
    return this.shareLink.attr("href", value);
  }

  getSharePath() {
    return this.el.data("share-path");
  }

  getShareUrl() {
    return this.el.data("share-url");
  }

  _shareMessageChanged() {
    return this.controller.shareMessageChanged(this.messageBox.val());
  }

  _bindEvents() {
    return this.messageBox.on("keyup", this._shareMessageChanged);
  }
};
